export default __webpack_public_path__ + "static/media/bluetooth.d1257c11.jpg";